import ReactDOM from 'react-dom/client'

import './index.css'
import './i18n'
import { configureLangHeader } from './libs/services'
import i18n from './i18n'
import { initSentry } from './libs/sentry'
import Root from './Root'

initSentry()
configureLangHeader(i18n.language)

ReactDOM.createRoot(document.getElementById('root')).render(<Root />)
